// // Start Header
    
// // End Header

// // Start Section-1
import { useEffect, useRef } from "react";

export default function HeroCanvas() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d", { alpha: true });

        let animationId;
        let stars = [];

        function resizeCanvas() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;

            const starsCount =
                window.innerWidth < 768 ? 120 : 200;

            stars = Array.from({ length: starsCount }, () => ({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 1.5 + 0.3,
                speed: Math.random() * 0.5 + 0.2,
            }));
        }

        function animate() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            ctx.fillStyle = "#fff";
            ctx.beginPath();

            for (const star of stars) {
                star.y += star.speed;

                if (star.y > canvas.height) {
                    star.y = -star.radius;
                    star.x = Math.random() * canvas.width;
                }

                ctx.moveTo(star.x + star.radius, star.y);
                ctx.arc(
                    star.x,
                    star.y,
                    star.radius,
                    0,
                    Math.PI * 2
                );
            }

            ctx.fill();

            animationId = requestAnimationFrame(animate);
        }

        resizeCanvas();

        animate();

        window.addEventListener("resize", resizeCanvas);

        return () => {
            cancelAnimationFrame(animationId);
            window.removeEventListener("resize", resizeCanvas);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            className="hero-canvas"
        />
    );
}
// End Section-1
// ========================================================================== //
// Start Section-5


// End Section-5
// ========================================================================== //
// Start Section-6
// let btn_item_none = document.getElementById("btn-view");
// let item_none = document.querySelectorAll(".item-none");


// btn_item_none.onclick = () => {

//     item_none.forEach(function (box) {

//         if (box.style.display === "block") {

//             box.style.display = "none";
//             btn_item_none.textContent = "View more";
//         }
//         else {

//             box.style.display = "block";
//             btn_item_none.textContent = "View less";
//         }
//     });

// };
// // Canvas2 sec-6
// ========================================================================== //
// Start Section-7
    
// // Canvas2 sec-7
// ========================================================================== //
